<template>
  <div class="q-pa-md">
    <!-- Chain name -->
    <!-- <p class="text-subtitle2 text-weight-regular text-grey-7">{{ store.chain_name }}</p> -->

    <div class="row q-mt-sm">
      <div>
        <a
          target="_blank"
          :href="`
          https://www.google.com/maps/place/${(store.street as string).replace(' ','+')},+${(store.city as string).replace(' ', '+')},+${store.state}
          `"
        >
          <q-btn round color="secondary" icon="map" />
        </a>
      </div>
      <div class="q-ml-sm">
        <address class="text-grey-7 tw-not-italic">
          {{ store.street }}<br />
          {{ store.city }}, {{ store.state }}
        </address>
      </div>
    </div>

    <chip-list @click="setModal('store_items', modalChipItems)" :items="storeItems"></chip-list>

    <div class="q-my-sm tw-grid tw-grid-cols-4 tw-gap-4">
      <div>
        <q-item-section>
          <q-item-label overline class="text-grey-7">
            {{ storeItemLabel('store_number') }}
          </q-item-label>
          <q-item-label> {{ store.store_number }} </q-item-label>
        </q-item-section>
      </div>
      <div>
        <q-item-section>
          <q-item-label overline class="text-grey-7">
            {{ storeItemLabel('chain_name') }}
          </q-item-label>
          <q-item-label>{{ store.chain_name }}</q-item-label>
        </q-item-section>
      </div>
      <div>
        <q-item-section>
          <q-item-label overline class="text-grey-7">
            {{ storeItemLabel('chain_short_name') }}
          </q-item-label>
          <q-item-label>{{ store.chain_short_name }}</q-item-label>
        </q-item-section>
      </div>
      <!-- <div>
        <q-item-section>
          <q-item-label overline class="text-grey-7">Some code</q-item-label>
          <q-item-label>FRED01</q-item-label>
        </q-item-section>
      </div> -->
      <div>
        <q-item-section>
          <q-item-label overline class="text-grey-7">
            {{ storeItemLabel('class_of_trade') }}
          </q-item-label>
          <q-item-label>{{ store.class_of_trade }}</q-item-label>
        </q-item-section>
      </div>
      <div>
        <q-item-section>
          <q-item-label
            overline
            @click.stop="
              setModal('store_manager', {
                contact_name: { value: store.contact_name ? store.contact_name : '', type: 'text' },
              })
            "
            class="text-grey-7"
          >
            {{ storeItemLabel('store_manager') }}
            <q-icon name="edit" size="10px" />
          </q-item-label>
          <q-item-label
            @click.stop="
              setModal('store_manager', {
                contact_name: { value: store.contact_name ? store.contact_name : '', type: 'text' },
              })
            "
          >
            {{ store.contact_name }}
          </q-item-label>
        </q-item-section>
      </div>
    </div>

    <div class="row q-mt-sm">
      <q-item-section class="q-pa-none col-3" @click="modalStoreNotes = true">
        <q-item-label
          overline
          class="text-grey-7"
          @click.stop="setModal('notes', { notes: { type: 'textarea', value: store.notes } })"
        >
          {{ storeItemLabel('notes') }}
          <q-icon name="edit" size="10px" />
        </q-item-label>
        <q-item-label
          @click.stop="setModal('notes', { notes: { type: 'textarea', value: store.notes } })"
        >
          {{ store.notes }}
        </q-item-label>
      </q-item-section>
    </div>

    <div class="q-pt-sm">
      <q-btn
        no-caps
        rounded
        flat
        color="primary"
        :label="storeItemLabel('suggestEdit')"
        @click="modalStoreRecap = true"
      />
    </div>

    <div class="row q-mt-sm">
      <!-- Notes -->
      <q-item class="q-pa-none col-3">
        <q-item-section> </q-item-section>
      </q-item>
    </div>

    <!-- Edit modal -->
    <q-dialog v-model="editModal">
      <form-store-profile
        :header="modalData.header"
        :data="modalData.data"
        :store-id="(store.store_id as number)"
      />
    </q-dialog>
  </div>
</template>
<script lang="ts">
import { computed, PropType, Ref, ref } from 'vue'
import { defineComponent } from 'vue'
import ChipList from './ChipList.vue'
import { useI18n } from 'vue-i18n'
import { useFormatTime } from '../composables/formatTime'
import { DataRow } from '../types/components/data-rendering'
import { useStoreProfiles } from '../store/useStoreProfiles'
import FormStoreProfile from './FormStoreProfile.vue'

export default defineComponent({
  components: { ChipList, FormStoreProfile },
  props: {
    store: {
      required: true,
      type: Object as PropType<DataRow>,
    },
    activeData: {
      required: true,
      type: Object as PropType<{ active: boolean; time: Ref<number> | undefined | null }>,
    },
    states: {
      required: true,
      type: Object as PropType<{
        isThisTimer: boolean
        noActiveTimer: boolean
        thisStoreInTimers: boolean
      }>,
    },
  },
  setup(props) {
    const { t } = useI18n({ useScope: 'global' })
    //store items
    const storeItemLabel = (key: string) => t(`storeItems.${key}`)

    const { getStoreEditableData } = useStoreProfiles()
    const storeData = computed(() => {
      return getStoreEditableData(props.store.store_id)!
    })

    const chipItems = computed<{ [key: string]: any }>(() => {
      const {} = storeData.value
      return storeData.value
    })
    const storeItems = computed(() =>
      Object.keys(chipItems.value).map((key) => {
        return {
          avatarText: chipItems.value[key] ? chipItems.value[key] : 0,
          label: storeItemLabel(key),
          key: key,
        }
      })
    )
    const modalChipItems = computed(() => {
      const newData: {
        [key: string]: { value: string | number; type: 'text' | 'number' | 'textarea' }
      } = {}
      Object.keys(chipItems.value).forEach((key) => {
        if (key != 'no_of_coupon_zones') {
          newData[key] = { type: 'number', value: chipItems.value[key] ? chipItems.value[key] : 0 }
        }
      })
      return newData
    })

    //Editing store data
    const editModal = ref(false)
    const modalData = ref<{
      header: string
      data: {
        [key: string]: { value: string | number; type: 'text' | 'number' | 'textarea' }
      }
    }>({
      header: '',
      data: {},
    })
    const setModal = (
      header: string,
      values: {
        [key: string]: { value: string | number; type: 'text' | 'number' | 'textarea' }
      }
    ) => {
      editModal.value = true
      modalData.value.header = `Store ${storeItemLabel(header)}`
      modalData.value.data = values
    }

    return {
      //store items
      storeItemLabel,
      storeItems, //for chips
      modalChipItems, //for modal
      //format
      useFormatTime,
      //modal
      editModal,
      setModal,
      modalData,
    }
  },
})
</script>
